// IMPORTANT: Keep in sync with functions/src/index.ts -> STRIPE_TAX_CALCULATION_ERROR_REASON
enum TAX_CALCULATION_ERROR_REASON {
    taxAddressInvalid = 'taxAddressInvalid',
    taxInputInvalid = 'taxInputInvalid',
    taxServiceUnavailable = 'taxServiceUnavailable',
}

export { TAX_CALCULATION_ERROR_REASON };
